import { useMutationWithErrorHandling, usePost } from '@app/sdk';
import { ConfigRule } from '@app/models';
import { tenantHierarchyBaseUrl } from '../BaseUrls';

export function usePreviewConfig() {
  const post = usePost(true, "tms");
  return useMutationWithErrorHandling({
    mutationFn: async ({
      organisationUnitId,
      categoryId,
      request,
    }: {
      organisationUnitId: string;
      categoryId: string;
      request: ConfigRule[];
    }) => {
      return await post(
        `${tenantHierarchyBaseUrl}/organisation-units/${organisationUnitId}/category/${categoryId}/preview-config`,
        request
      );
    },
  });
}
